export const APP_NAME = 'Shesha Boilerplate';

export const ACCESS_TOKEN_NAME = 'xDFcxiooPQxazdndDsdRSerWQPlincytLDCarcxVxv';

export const MAP_BOX_ACCESS_TOKEN =
  'pk.eyJ1IjoibWFzZXJ1a2dhbnlhZ28iLCJhIjoiY2x1NnF1ZjBhMHBrMDJqbnZna25pZ2JudSJ9.iVCq9eqT2Pz2oYdBWdOKrw';

export const BASE_URL =
  process.env.BACKEND_URL === '' || process.env.BACKEND_URL === undefined
    ? 'https://pd-dispatcher-api-test.shesha.dev/'
    : process.env.BACKEND_URL;

export const DISP_GLOBAL_STATE_KEYS = Object.freeze({
  SelectedIncidentId: 'SELECTED_INCIDENT_ID',
  SetCurrentPointOnMap: 'SET_CURRENT_POINT_ON_MAP',
  CreateEmsIncident: 'CREATE_EMS_INCIDENT',
  CurrentAgent: 'CURRENT_AGENT',
  StartEditIncident: 'START_EDIT_INCIDENT',
  UpdateEmsIncident: 'UPDATE_EMS_INCIDENT',
  PointOnMap: 'POINT_ON_MAP',
  IsIncidnetOwner: 'IS_INCIDENT_OWNER',
  CheckExistingReporterNumber: 'CHECK_EXISTING_REPORTER_NUMBER',
  ResponseUnitTable: 'RESPONSE_UNIT_TABLE',
  setDuplicateIncidentLatLong: 'SET_DUPLICATE_INCIDENT_LAT_LONG',
  CheckExistingIdentityNumber: 'CHECK_EXISTING_IDENTITY_NUMBER',
  StartCreateIncident: 'START_CREATE_INCIDENT',
});
